import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/mosquito1.jpeg";
import nsf from "../assets/NSF.png";
import usf from "../assets/USF.png";
import iges from "../assets/IGES.png";
import mhm from "../assets/MHM.png";
import { useAuth } from "../contexts/AuthContext";
import { useHistory } from "react-router-dom";

export default function Navbar() {
  const [error, setError] = useState("");
  const { currentUser, logout } = useAuth();
  const history = useHistory();
  async function handleLogout() {
    setError("");

    try {
      await logout();
      history.push("/");
    } catch {
      setError("Failed to log out");
    }
  }

  return (
    <nav className="site-nav family-sans navbar navbar-expand higher fixed-top" style={{ backgroundColor: "#80B0A6"}}>
      <div className="container-fluid">
        <div className="navbar-brand text-center">
          <Link to="/">
            <img src={logo} alt="logoimg" height="50" />
          </Link>
        </div>
        <div className="navbar-nav mr-auto">
          
        </div>
        <div className="navbar-brand ml-auto">
            <img src={nsf} alt="logoimg" height="50" />&nbsp;
            <img src={usf} alt="logoimg" height="50" />&nbsp;
            <img src={mhm} alt="logoimg" height="50" />&nbsp;
            <img src={iges} alt="logoimg" height="50" />
        </div>
      </div>
    </nav>
  );
}
